import { Capacitor, registerPlugin } from '@capacitor/core';

interface PbforkUiPlugin {
  enterFullscreen(): Promise<void>;
  exitFullscreen(): Promise<void>;
}

const plugin = Capacitor.isNativePlatform() ? registerPlugin<PbforkUiPlugin>('PbforkUi') : null;

/**
 * Tam ekran oynatmada Android sistem çubuklarını gizler/gösterir.
 * Web'de ve plugin yoksa sessizce yok sayılır.
 */
export async function setImmersiveFullscreen(enabled: boolean): Promise<void> {
  if (plugin === null) return;
  try {
    if (enabled) {
      await plugin.enterFullscreen();
    } else {
      await plugin.exitFullscreen();
    }
  } catch {
    // Eski cihaz/plugin yoksa SystemBars yolu zaten denendi.
  }
}
